import { useEffect, useRef, useState } from 'react';
import b from '../../services/api/Boards';
import { getCrmCheckoutUrl, goToCrmCheckout } from './crmCheckoutNavigation';

export function useCrmBoardCreationAccess({ lang, onAllowed }) {
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState('');
  const pending = useRef(false);
  const mounted = useRef(true);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  const startCreate = async () => {
    if (pending.current) return;
    pending.current = true;setChecking(true);setError('');
    try {
      const response = await b.getCrmCreationAccess(lang || 'en');
      if (!mounted.current) return;
      if (!response || response.status >= 400) throw new Error('Access unavailable');
      const access = response.data;
      if (access?.canCreateBoard === true && ['active_crm_subscription', 'privileged_role'].includes(access.reason)) {
        onAllowed();return;
      }
      const checkoutUrl = getCrmCheckoutUrl(access);
      if (!checkoutUrl) throw new Error('Invalid access decision');
      goToCrmCheckout(checkoutUrl);
    } catch {
      if (mounted.current) setError('Could not verify CRM access. Please try again.');
    } finally {
      pending.current = false;if (mounted.current) setChecking(false);
    }
  };
  return { startCreate, checking, error };
}
